{
  "name": "camerite2.0-platform-frontend",
  "version": "1.0.1-0.1",
  "scripts": {
    "start": "ng serve",
    "start:dev": "ng serve --configuration=development",
    "start:stg": "ng serve --configuration=staging",
    "start:prd": "ng serve --configuration=production",
    "build": "ng build --configuration=staging",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:ci": "ng test --no-watch",
    "test:moni": "ng test --no-watch --ts-config=tsconfig.moni.spec.json --include='src/app/features/integrations-moni/*.spec.ts'",
    "test:coverage": "ng test --no-watch --coverage",
    "test:ui": "ng test --ui",
    "lint": "ng lint",
    "lint:fix": "eslint . --ext .ts --fix",
    "eslint": "eslint . --ext .ts",
    "format": "prettier --write \"src/**/*.ts\" \"src/**/*.html\"",
    "usage-metrics:sink": "node tools/telemetry-sink/server.mjs",
    "prepare": "husky"
  },
  "lint-staged": {
    "*.ts": [
      "eslint --fix",
      "prettier --write"
    ],
    "*.html": [
      "prettier --write"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.16",
    "@angular/cdk": "^21.0.0",
    "@angular/common": "^21.2.16",
    "@angular/compiler": "^21.2.16",
    "@angular/core": "^21.2.16",
    "@angular/fire": "^20.0.0",
    "@angular/forms": "^21.2.16",
    "@angular/google-maps": "^21.2.6",
    "@angular/platform-browser": "^21.2.16",
    "@angular/platform-browser-dynamic": "^21.2.16",
    "@angular/router": "^21.2.16",
    "@fortawesome/fontawesome-free": "^7.2.0",
    "@googlemaps/markerclusterer": "^2.6.2",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@ngxs/devtools-plugin": "^21.0.0",
    "@ngxs/store": "^21.0.0",
    "@primeng/themes": "^21.0.0",
    "@primeuix/themes": "^1.0.0",
    "@theonlyducks/videojs-zoom": "^1.3.6",
    "@types/video.js": "^7.3.58",
    "chart.js": "^4.4.0",
    "chartjs-adapter-date-fns": "^3.0.0",
    "chartjs-chart-matrix": "^2.0.1",
    "chartjs-plugin-datalabels": "^2.2.0",
    "chroma-js": "^3.1.2",
    "d3": "^7.9.0",
    "d3-axis": "^3.0.0",
    "d3-interpolate": "^3.0.1",
    "d3-scale": "^4.0.2",
    "d3-selection": "^3.0.0",
    "d3-time-format": "^4.1.0",
    "date-fns": "^4.1.0",
    "dayjs": "^1.11.13",
    "echarts": "^6.0.0",
    "hls.js": "^1.6.2",
    "jszip": "^3.10.1",
    "martinez-polygon-clipping": "^0.7.4",
    "moment": "^2.30.1",
    "ngx-device-detector": "^10.0.2",
    "ngx-echarts": "^21.0.0",
    "onnxruntime-web": "1.22.0",
    "primeicons": "^7.0.0",
    "primeng": "^21.0.0",
    "qrcode": "^1.5.4",
    "quill": "^2.0.2",
    "rxjs": "~7.8.2",
    "shaka-player": "^4.14.11",
    "swiper": "^12.2.0",
    "tailwindcss-primeui": "^0.5.1",
    "tslib": "^2.8.0",
    "uuid": "^11.1.0",
    "video.js": "^8.22.0",
    "vis-timeline": "^7.7.3",
    "zone.js": "~0.15.0"
  },
  "overrides": {
    "sockjs": {
      "uuid": "^11.1.1"
    },
    "@babel/core": "^7.29.7",
    "esbuild": "^0.28.1",
    "hono": "^4.12.27",
    "http-proxy-middleware": "^3.0.7",
    "js-yaml": "^4.2.0",
    "piscina": "^5.2.0",
    "protobufjs": "^7.6.3",
    "undici": "^7.28.0",
    "vite": "^7.3.5",
    "webpack-dev-server": "^5.2.5",
    "ws": "^8.21.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.14",
    "@angular-eslint/eslint-plugin-template": "^21.4.0",
    "@angular-eslint/template-parser": "^21.4.0",
    "@angular/cli": "^21.2.14",
    "@angular/compiler-cli": "^21.2.16",
    "@commitlint/cli": "^19.8.0",
    "@commitlint/config-conventional": "^19.8.0",
    "@types/chroma-js": "^3.1.1",
    "@types/d3": "^7.4.3",
    "@types/google.maps": "^3.58.1",
    "@types/node": "^22.13.10",
    "@types/qrcode": "^1.5.6",
    "@typescript-eslint/eslint-plugin": "^8.60.1",
    "@typescript-eslint/parser": "^8.60.1",
    "@vitest/coverage-v8": "^4.1.9",
    "@vitest/ui": "^4.1.9",
    "angular-eslint": "^21.4.0",
    "autoprefixer": "^10.4.20",
    "commitlint": "^19.8.0",
    "eslint": "^9.22.0",
    "eslint-config-prettier": "^10.1.1",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^5.2.3",
    "eslint-plugin-unused-imports": "^4.1.4",
    "husky": "^9.1.7",
    "jsdom": "^29.1.1",
    "lint-staged": "^15.4.3",
    "ngx-translate-testing": "^7.0.0",
    "postcss": "^8.4.49",
    "prettier": "^3.5.3",
    "tailwindcss": "^3.4.17",
    "ts-node": "^10.9.2",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.60.1",
    "vitest": "^4.1.9",
    "vitest-sonar-reporter": "^3.0.0"
  }
}
